 "use client"

import { useEffect, useState } from "react"
import Image from "next/image"

type Slide = {
  id: number
  title: string
  subtitle: string
  image: string
}

const slides: Slide[] = [
  {
    id: 1,
    title: "Timeless Elegance",
    subtitle: "Discover our exquisite collection of fine jewelry",
    image: "/luxury-jewelry-collection-elegant.jpg",
  },
  {
    id: 2,
    title: "Radiant Beauty",
    subtitle: "Handcrafted pieces for the modern woman",
    image: "/luxury-rings-and-necklaces.jpg",
  },
  {
    id: 3,
    title: "Precious Moments",
    subtitle: "Celebrate life with our signature designs",
    image: "/luxury-earrings-and-bracelets.jpg",
  },
]

export default function HomeCarousel() {
  const [current, setCurrent] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length)
    }, 5000)

    return () => clearInterval(timer)
  }, [])

  const next = () => setCurrent((prev) => (prev + 1) % slides.length)
  const prev = () => setCurrent((prev) => (prev - 1 + slides.length) % slides.length)

  return (
    <section className="relative w-full h-96 md:h-[600px] overflow-hidden bg-beige">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? "opacity-100" : "opacity-0"
          }`}
        >
          <Image
            src={slide.image}
            alt={slide.title}
            fill
            priority={index === 0}
            sizes="100vw"
            className="object-cover"
          />
          <div className="absolute inset-0 bg-brown-dark/40" />

          <div className="absolute inset-0 flex items-center justify-center">
            <div className="max-w-4xl mx-auto px-4 text-center text-cream space-y-4">
              <p className="text-sm uppercase tracking-[0.25em] text-gold-light">
                LUXURY JEWELRY
              </p>
              <h2 className="text-3xl md:text-6xl font-serif font-bold">
                {slide.title}
              </h2>
              <p className="text-base md:text-lg text-cream/80">
                {slide.subtitle}
              </p>
              <div className="flex justify-center gap-3 mt-4">
                {/* <button className="px-6 py-3 bg-gold text-cream rounded-full text-sm font-medium hover:bg-gold-light transition-colors">
                  Shop Now
                </button> */}

                <a
                  href="#latest-arrivals"
                  className="px-6 py-3 border border-cream/60 text-sm font-medium rounded-full hover:bg-cream/10 transition-colors"
                >
                  Explore Collection
                </a>
              </div>
            </div>
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={prev}
        className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white rounded-full p-2 transition-colors"
        aria-label="Previous slide"
      >
        <span className="inline-block rotate-180">&rsaquo;</span>
      </button>

      <button
        type="button"
        onClick={next}
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white rounded-full p-2 transition-colors"
        aria-label="Next slide"
      >
        <span>&rsaquo;</span>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
        {slides.map((slide, index) => (
          <button
            key={slide.id}
            type="button"
            onClick={() => setCurrent(index)}
            className={`w-2.5 h-2.5 rounded-full border border-white ${
              index === current ? "bg-white" : "bg-transparent"
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  )
}
